export function LogoMark() {
  return (
    <svg className="brand__glyph" viewBox="0 0 32 32" aria-hidden="true">
      <path className="brand__glyph-peak" d="M9 23.5 16 8.5l7 15" />
      <path className="brand__glyph-spark" d="M16 16.7q0 2.8 2.8 2.8-2.8 0-2.8 2.8 0-2.8-2.8-2.8 2.8 0 2.8-2.8Z" />
    </svg>
  );
}
